import {Component, Input, OnInit} from '@angular/core';
import {TimeslotReadonly} from '../../api/models/timeslot-readonly';
import {UserService} from '../../services/user.service';

@Component({
  standalone: false,
  selector: 'app-participant-count',
  templateUrl: './participant-count.component.html',
  styleUrls: ['./participant-count.component.scss'],
})
export class ParticipantCountComponent implements OnInit {

  @Input() timeslot: TimeslotReadonly;
  loggedIn = false;
  account = null;
  constructor(private userService: UserService,) { }

  ngOnInit() {

    this.userService.getAccount().subscribe(x => this.account = x);
  }

}
